import scroll from 'utilities/scroll';

export const useResidentValidation = ({ handleShowAdvise }) => {
    const handleValidateResident = ({ isResident, isContactCenter }) => {
        const shouldShowResidentAdvise = !isResident && !isContactCenter;
        handleShowAdvise({ resident: shouldShowResidentAdvise });

        if (shouldShowResidentAdvise) {
            const residentDisclosureElement = document.getElementById('countryRestriction');
            scroll.transition(residentDisclosureElement, 'top');
        }
    };

    return { handleValidateResident };
};
